export const RESOURCE_TYPE_NOOP = 'NOOP';
export const MIN_MAX_AGE = 5 * 1000;
